export enum UnitSubset {
  MOLE_FRACTION_NO_PPM = 'MoleFractionNoPpm',
  VOLUME_FRACTION_NO_PPM = 'VolumeFractionNoPpm',
}
